module.exports = __webpack_public_path__ + "public/images/mug.dd4d3c34edefb43671e8c34c4fcfb1ab.png";